import { Box, styled } from '@mui/material';

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4, 2),
  width: '100%',
  minWidth: '400px',
  maxWidth: '500px'
}));
